import { PropTypes } from 'react-desc';
import { b as checkboxVariants, a as CHECKBOX_VARIANT } from '../prop-types-cc01d273.js';

var checkboxProps = {
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).description('Displayable label for the checkbox'),
  htmlFor: PropTypes.element.description('html for attr'),
  hasError: PropTypes.bool.description('Whether the checkbox has error or not').defaultValue(false),
  readOnly: PropTypes.bool.description('Whether the checkbox is read only or not').defaultValue(false),
  disabled: PropTypes.bool.description('Whether the checkbox is disabled or not').defaultValue(false),
  checked: PropTypes.oneOfType([PropTypes.oneOf(['mixed']), PropTypes.bool]).description('Whether the checkbox is checked, mixed or unchecked').defaultValue(false),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).description('Value that takes the checkbox if it is checked'),
  variant: PropTypes.oneOf(checkboxVariants).description('checbkox variant').defaultValue(CHECKBOX_VARIANT.DEFAULT),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).description('children elements'),
  onChange: PropTypes.func.description('function executed when the checkbox changes'),
  name: PropTypes.string.description('checkbox s name')
};

export { checkboxProps };
//# sourceMappingURL=props.js.map
